import { ServiceApplication_Key } from "../../../../config/helpers";
import { INoticeDetailsReturn, INoticeGet} from "../../../../models/interfaces/INotice";


import { apiSlice } from "../../api";

export interface noticeApiQueryBody {
    Application_Key: string;
    // eslint-disable-next-line
    Values: any;
}

export const noticeApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    BOfetchNotice: builder.query<INoticeDetailsReturn, INoticeGet>({
    query: ({ EAN, IdNotice }) => {
      const body: noticeApiQueryBody = {
        Application_Key: ServiceApplication_Key,
        Values: {
          EAN,
          IdNotice,
        },
      };
      return {
        url: "/BO/Notice/Notice_Get",
        method: "POST",
        body: body,
      };
    },
  }),
  
  }),
});
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useBOfetchNoticeQuery,
} = noticeApi;

